module.exports = __webpack_public_path__ + "7558bac4a9b953d12a162fb7b7e0d2f6.svg";